// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.1
//   protoc               v4.23.4
// source: diagnostics/client_commands.proto

/* eslint-disable */

export interface ExecuteClientCommand {
  id: string;
  command: string;
  payload?: string | undefined;
  validAfter?: string | undefined;
  validUntil?: string | undefined;
  clientVersion?: string | undefined;
  clientPlatform?: string | undefined;
}

export interface ExecuteClientCommandResponse {
  id: string;
  status: ExecuteClientCommandResponse_Status;
  command: string;
  response?: string | undefined;
  errorMessage?: string | undefined;
  executedAt?: string | undefined;
  duration?: string | undefined;
}

export const ExecuteClientCommandResponse_Status = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  SKIPPED: "SKIPPED",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type ExecuteClientCommandResponse_Status =
  typeof ExecuteClientCommandResponse_Status[keyof typeof ExecuteClientCommandResponse_Status];

export namespace ExecuteClientCommandResponse_Status {
  export type SUCCESS = typeof ExecuteClientCommandResponse_Status.SUCCESS;
  export type ERROR = typeof ExecuteClientCommandResponse_Status.ERROR;
  export type SKIPPED = typeof ExecuteClientCommandResponse_Status.SKIPPED;
  export type UNRECOGNIZED = typeof ExecuteClientCommandResponse_Status.UNRECOGNIZED;
}
